import { format } from "date-fns"
import { FileText, Calendar } from "lucide-react"

// Custom Card Components
const Card = ({ children, className = "" }) => (
  <div className={`bg-white rounded-xl shadow-sm border border-gray-200 ${className}`}>{children}</div>
)

const CardContent = ({ children, className = "" }) => <div className={`p-6 ${className}`}>{children}</div>

const RecentGrievances = ({ grievances }) => {
  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "complete":
        return "bg-green-100 text-green-800"
      case "inprogress":
        return "bg-orange-100 text-orange-800"
      case "assigned":
        return "bg-blue-100 text-blue-800"
      default:
        return "bg-gray-100 text-gray-800"
    }
  }

  const getPriorityColor = (priority) => {
    switch (priority.toLowerCase()) {
      case "high":
        return "bg-red-100 text-red-800"
      case "medium":
        return "bg-yellow-100 text-yellow-800"
      case "low":
        return "bg-green-100 text-green-800"
      default:
        return "bg-gray-100 text-gray-800"
    }
  }

  const latestGrievances = [...grievances].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).slice(0, 10)

  return (
    <Card className="h-[400px]">
      <CardContent className="p-6 h-full flex flex-col">
        <h3 className="text-xl font-bold text-color mb-4 flex items-center gap-2">
          <FileText size={24} className="text-green-600" />
          Recent Grievances
        </h3>

        <div className="flex-1 overflow-auto">
          <div className="space-y-3">
            {latestGrievances.map((grievance, index) => (
              <div
                key={grievance._id}
                className="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:shadow-md transition-shadow"
              >
                <div className="flex justify-between items-start mb-2">
                  <div className="flex-1">
                    <h4 className="font-semibold text-gray-900 text-sm mb-1">{grievance.grievanceTitle}</h4>
                    <p className="text-xs text-gray-600">Created by: {grievance.createdByUserName}</p>
                  </div>
                  <span className="text-xs font-mono text-blue-600 bg-blue-50 px-2 py-1 rounded">{grievance._id}</span>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(grievance.status)}`}>
                      {grievance.status.charAt(0).toUpperCase() + grievance.status.slice(1)}
                    </span>
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(grievance.priority)}`}
                    >
                      {grievance.priority.charAt(0).toUpperCase() + grievance.priority.slice(1)}
                    </span>
                  </div>
                  <div className="flex items-center gap-1 text-xs text-gray-500">
                    <Calendar size={12} />
                    {format(new Date(grievance.createdAt), "MMM dd")}
                  </div>
                </div>

                <div className="mt-2 text-xs text-gray-600">Category: {grievance.categoryName}</div>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

export default RecentGrievances
